import { createSlice } from '@reduxjs/toolkit';

import {downloadSampleFile, getStyleDetails, ingestVendorSplitFile, updateStyleDetails} from '../../apis';

export const ProductMapping = createSlice({

    name: 'productMapping',
    initialState: {
        loading: false,
        error: '' ,
        productMappingData: [],
        updateStyleDetailsSuccess: false,
        uploadIngestVendorFileSuccess: false,
        downloadIngestVendorFileSuccess: false,
    },
    reducers: {
        clearError: (state, action) => {
            return {
                ...state,
                error: action.payload
            }
        },
        clearUpdateStyleDetailsSuccess: (state, action) => {
            return {
                ...state,
                updateStyleDetailsSuccess: action.payload
            }
        },
        clear: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            }
        }
    },

    extraReducers: (builder) => {
        builder.addCase(getStyleDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getStyleDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.productMappingData = action.payload.data;
        })
        builder.addCase(getStyleDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
        builder.addCase(updateStyleDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updateStyleDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.updateStyleDetailsSuccess = true;
        })
        builder.addCase(updateStyleDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload.message;
        })
        builder.addCase(ingestVendorSplitFile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(ingestVendorSplitFile.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadIngestVendorFileSuccess = true;
        })
        builder.addCase(ingestVendorSplitFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(downloadSampleFile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(downloadSampleFile.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadIngestVendorFileSuccess = true;
        })
        builder.addCase(downloadSampleFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
    }
})

export const {clearError, clearUpdateStyleDetailsSuccess} = ProductMapping.actions
export default ProductMapping.reducer